import { Component } from '@angular/core';
import { HubService } from '../../../shared/services/hub.service';
import { AngularFireDatabase, AngularFireList } from '@angular/fire/database';
import { Observable } from 'rxjs/Observable';
import { TabRoomData } from '../../../shared/components/tabs/models/tab-room.model';
import { Router } from '@angular/router';
import { UserService } from '../../../shared/services/user.service';
import { TabAction } from '../../../shared/components/tabs/components/tab-room/tab-room.component';
import { PlayerService } from '../../../shared/services/player.service';

@Component({
  selector: 'app-room-select',
  templateUrl: './room-select.component.html',
  styleUrls: ['./room-select.component.scss']
})
export class RoomSelectComponent {
  hubRef: AngularFireList<any>;
  hub: Observable<any[]>;

  get user() {
    return this.userService.user;
  }

  constructor(
    private router: Router,
    public afd: AngularFireDatabase,
    private hubService: HubService,
    private userService: UserService,
    // private snackBar: MatSnackBar,
    private playerService: PlayerService
  ) {
    this.hubRef = afd.list('hub');
    this.hub = this.hubRef.snapshotChanges().map(changes => {
      return changes.map(c => ({ key: c.payload.key, ...c.payload.val() }));
    });
    /* this.userService.auth.user.subscribe(user => {
      this.userService.user = user;
    }); */
  }

  openSnackBar(message: string, action: string) {
    /* this.snackBar.open(message, action, {
      duration: 2000
    }); */
    alert(message);
  }

  tabs: { id: string; label: string }[] = [
    {
      id: 'playNow',
      label: 'Play Now'
    },
    {
      id: 'gameInProgress',
      label: 'Games In Progress'
    }
    /* {
      id: 'played',
      label: 'Played'
    }, */
  ];

  selectedTab: { id: string; label: string } = this.tabs[0];

  selectTabAction(selectTabAction: { id: string; label: string }) {
    this.selectedTab = selectTabAction;
  }

  selectedTabData(hubDatas) {
    return hubDatas
      ? hubDatas.filter(hubData => hubData.tabKey === this.selectedTab.id)
      : [];
  }

  // action = createRoom
  get _userRestrictions() {
    return this.userService.userRestrictions();
  }

  createHub() {
    if (this._userRestrictions.createRoom) {
      /* this.hubService.deleteHub(this.user.uid).then(
          res => {
            const hub = this.hubService.addHub(this.user);
            this.router.navigate(['/mc/room-creation/' + this.user.uid]);
          }
        ) */
      const hub = this.hubService.addHub(this.user);
      this.router.navigate(['/mc/room-creation/' + this.user.uid]);
    } else {
      this.openSnackBar('Login required', '⚠️');
    }
  }

  joinCreateRoom(tabRoomData: TabRoomData) {
    if (this._userRestrictions.joinGameAsPlayer) {
      if (tabRoomData.tabKey === 'playNow') {
        this.router.navigate(['/mc/room-creation/' + tabRoomData['key']]);
      } else {
        this.router.navigate(['/mc/play', tabRoomData.roomId]);
      }
    } else {
      this.openSnackBar('Login required', '⚠️');
    }
  }

  watchCreateRoom(tabRoomData: TabRoomData) {
    if (tabRoomData.tabKey === 'playNow') {
      this.router.navigate(['/mc/room-creation/' + tabRoomData['key']]);
    } else {
      this.router.navigate(['/mc/play', tabRoomData.roomId]);
    }
  }

  // actions displayed in the tab
  tabActions(tab): string[] {
    const matchingRoomUser =
      tab.players &&
      tab.players.find(roomUser => roomUser.uid === this.user.uid);
    const userRestrictions = this.userService.userRestrictions(
      matchingRoomUser
    );
    let result = [];
    if (userRestrictions.joinGameAsPlayer) {
      result.push(TabAction.JOIN);
    }
    if (userRestrictions.joinGameAsSpectator) {
      result.push(TabAction.WATCH);
    }
    return result;
  }
}
